import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { customFetchV2 } from '../services/custom-fetch-v2';
import { DevicePlan } from './useGetCurrentUserDevices';

interface UseGetAvailableServicePlansParams {
  deviceId: string;
}

/**
 * API query to retrieve user info.
 */
const getAvailableServicePlans = async (deviceId: string): Promise<DevicePlan[] | null> => {
  const response: any = await customFetchV2<DevicePlan[]>(`/api/v2/devices/${deviceId}/available-plans`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error('Unable to get available plans for device');
  }

  return response.data;
};

/**
 * React hook that will fetch and refresh the logged in users devices.
 */
const useGetAvailableServicePlans =
  ({ deviceId }: UseGetAvailableServicePlansParams): UseQueryResult<DevicePlan[], unknown> =>
    useQuery(['useGetAvailableServicePlans', deviceId], () => getAvailableServicePlans(deviceId), {
      enabled: true,
      retry: false,
    });

/** Exports */
export { useGetAvailableServicePlans };
